import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

export interface NavigationProps {
  user?: {
    id: string;
    username: string;
    role: 'admin' | 'staff';
  } | null;
  onLogout?: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ 
  user, 
  onLogout 
}) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-title-link">
          <h1 className="nav-title">介護スケジュール管理システム</h1>
        </Link>
        
        <div className="nav-center">
          <div className="nav-links">
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
            >
              スケジュール
            </Link>
            
            <Link
              to="/users"
              className={`nav-link ${isActive('/users') ? 'active' : ''}`}
            >
              利用者管理
            </Link>
            
            <Link
              to="/upload"
              className={`nav-link ${isActive('/upload') ? 'active' : ''}`}
            >
              ファイルアップロード
            </Link>
          </div>
        </div>

        {user && (
          <div className="nav-user">
            <span className="user-info">
              {user.username} ({user.role === 'admin' ? '管理者' : 'スタッフ'})
            </span>
            <button 
              className="logout-btn"
              onClick={onLogout}
            >
              ログアウト
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;